import ConfirmModal from './ConfirmModal.vue'
import Vue from 'vue'

const ConfirmModalConstructor = Vue.extend(ConfirmModal)

export default function (options) {
  return new Promise((resolve, reject) => {
    if (typeof options === 'string') {
      options = {
        message: options
      }
    }

    const instance = new ConfirmModalConstructor({
      data: options
    })

    instance.handleConfirm = function () {
      resolve(true)
      //不关闭弹窗
      instance.visible = options.doNotCloseDialog === true
    }
    instance.handleCancel = function () {
      resolve(false)
      instance.visible = false
    }
    instance.handleClose = function () {
      resolve(undefined)
      instance.visible = false
    }

    instance.$mount()
    document.body.appendChild(instance.$el)
  })
}
